const AuthContainerItem = ({ className, children }) => {
    return <div className={className}>{children}</div>;
};

export default AuthContainerItem;
